<ng-container [formGroup]="form">
  <nz-form-item>
    <nz-form-label nzFor="definition" [nzRequired]="isRequired">
      Operational Definition
    </nz-form-label>
    <nz-form-control>
      <textarea
        id="definition"
        name="definition"
        aria-label="Operational Definition"
        rows="5"
        nz-input
        placeholder="Enter the operational definition"
        formControlName="operationalDefinition"
        (input)="
          onControlInputChange($event, form.get('operationalDefinition'))
        ">
      </textarea>
      <div class="mt-3 remaining-text">
        {{ form.value?.operationalDefinition?.length }} of 4000 characters used
        <div class="btn-wrapper-end">
          <button
            nz-button
            nzType="text"
            class="primary-text-btn"
            (click)="openPdfModal.emit()">
            Operational Definition Sample
          </button>
        </div>
      </div>
      <div
        class="ant-form-item-explain-error mt-3"
        *ngIf="form.get('operationalDefinition')?.errors?.['required']">
        Please enter your Operational Definition.
      </div>
    </nz-form-control>
  </nz-form-item>
</ng-container>
